import React from "react";
import { CheckIcon } from "../common/icons/CheckIcon";
import { PrimaryButton } from "../disease_knowledge/components/PrimaryButton";
import classes from "./CompleteVerifyContent.module.scss";

export function CompleteVerifyContact() {

    const onClick = () => {
        window.close();
    };

    return (
        <div className={classes.container}>
            <div className={classes.message}>
                <CheckIcon size={"40px"}/>
                メールアドレスの承認が完了しました
            </div>
            <PrimaryButton onClick={onClick}>閉じる</PrimaryButton>
        </div>
    );
}

